var _path, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveFromInterviewNes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5547 13.2812L12.2618 12.5741C12.0743 12.3866 11.8199 12.2812 11.5547 12.2812V13.2812ZM15.2734 17L14.5663 17.7071C14.8523 17.9931 15.2824 18.0787 15.6561 17.9239C16.0298 17.7691 16.2734 17.4045 16.2734 17H15.2734ZM15.2734 13.2764L15.2041 12.2788C14.68 12.3152 14.2734 12.751 14.2734 13.2764H15.2734ZM4.1875 4.125C4.1875 3.57272 4.63522 3.125 5.1875 3.125V1.125C3.53065 1.125 2.1875 2.46815 2.1875 4.125H4.1875ZM4.1875 11.2812V4.125H2.1875V11.2812H4.1875ZM5.1875 12.2812C4.63522 12.2812 4.1875 11.8335 4.1875 11.2812H2.1875C2.1875 12.9381 3.53065 14.2812 5.1875 14.2812V12.2812ZM11.5547 12.2812H5.1875V14.2812H11.5547V12.2812ZM10.8476 13.9884L14.5663 17.7071L15.9805 16.2929L12.2618 12.5741L10.8476 13.9884ZM16.2734 17V13.2764H14.2734V17H16.2734ZM16.1328 11.2812C16.1328 11.8095 15.7226 12.2428 15.2041 12.2788L15.3427 14.274C16.9021 14.1657 18.1328 12.8676 18.1328 11.2812H16.1328ZM16.1328 4.125V11.2812H18.1328V4.125H16.1328ZM15.1328 3.125C15.6851 3.125 16.1328 3.57272 16.1328 4.125H18.1328C18.1328 2.46815 16.7897 1.125 15.1328 1.125V3.125ZM5.1875 3.125H15.1328V1.125H5.1875V3.125Z",
    fill: "#3CB4E5"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 17.9263,
    y1: 1.40764,
    x2: 1.40764,
    y2: 15.0112,
    stroke: "#3CB4E5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveFromInterviewNes);
export default __webpack_public_path__ + "static/media/removeFromInterviewNes.a96849ac49b36a44f998f4df701cc427.svg";
export { ForwardRef as ReactComponent };